/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Auth_Desc4Inputs */

const en_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2.1 flows scoped per user, so agents act with least privilege.`)
};

const ar_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفقات OAuth 2.1 بنطاق لكل مستخدم، لتعمل الوكلاء بأقل الصلاحيات.`)
};

const bn_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতি ব্যবহারকারী স্কোপে OAuth 2.1 ফ্লো, যাতে এজেন্টরা সর্বনিম্ন অধিকারে চলে।`)
};

const de_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth-2.1-Flows pro Nutzer mit begrenztem Umfang, damit Agenten mit minimalen Rechten handeln.`)
};

const es_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos OAuth 2.1 con alcance por usuario, para que los agentes actúen con privilegios mínimos.`)
};

const fr_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux OAuth 2.1 à portée par utilisateur, pour que les agents agissent avec le moindre privilège.`)
};

const pt_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos OAuth 2.1 com âmbito por utilizador, para os agentes agirem com privilégios mínimos.`)
};

const zh_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按用户授权的 OAuth 2.1 流程，让助手以最小权限行动。`)
};

const tr_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı başına kapsamlı OAuth 2.1 akışları, ajanlar en az yetkiyle hareket eder.`)
};

const ru_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2.1-флоу со скоупом на пользователя, чтобы агенты действовали с минимальными правами.`)
};

const pl_svc_mcp_server_development_auth_desc4 = /** @type {(inputs: Svc_Mcp_Server_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przepływy OAuth 2.1 z zakresem na użytkownika, by agenci działali z minimalnymi prawami.`)
};

/**
* | output |
* | --- |
* | "OAuth 2.1 flows scoped per user, so agents act with least privilege." |
*
* @param {Svc_Mcp_Server_Development_Auth_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_auth_desc4 = /** @type {((inputs?: Svc_Mcp_Server_Development_Auth_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Auth_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "de") return de_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "es") return es_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_auth_desc4(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_auth_desc4(inputs)
	return en_svc_mcp_server_development_auth_desc4(inputs)
});
export { svc_mcp_server_development_auth_desc4 as "svc_mcp-server-development_AUTH_desc" }